import {
  FavoriteCollectionService,
  FavoriteLibService,
  FavoriteNibbleService
} from '@aipb/personal-content/data-access';
import { NibbleCut } from '@aipb/personal-content/shared/model';
import { SnackbarService } from '@aipb/ui/snackbar';
import { UseCase } from '@aipb/util/usecase';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { finalize, mergeMap, tap } from 'rxjs';

interface RemoveDto {
  nibbleCut: NibbleCut;
  collectionId: string;
  isFavorites: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class RemoveUseCase implements UseCase<RemoveDto> {
  private nibbleService = inject(FavoriteNibbleService);
  private favoriteCollectionService = inject(FavoriteCollectionService);
  private favoriteLibService = inject(FavoriteLibService);
  private snackbar = inject(SnackbarService);
  private transloco = inject(TranslocoService);

  execute(data: RemoveDto) {
    const snackbarRef = this.snackbar.loading(
      this.transloco.translate('personal_content.messages.remove_nibble_from_collection_loading')
    );

    return this.nibbleService.deleteFromCollection(data.nibbleCut, data.collectionId).pipe(
      mergeMap(() => this.favoriteCollectionService.get(data.collectionId, 'on')),
      tap(() => {
        snackbarRef.dismiss();
        this.favoriteLibService.refreshPlugin();
        this.snackbar.open(
          this.transloco.translate(
            data.isFavorites
              ? 'personal_content.messages.nibble_deleted_from_favorites'
              : 'personal_content.messages.nibble_deleted',
            {
              // @ts-expect-error foo
              value: data.nibbleCut.clientInfo.shortLabel
            }
          ),
          'success'
        );
      }),
      finalize(() => {
        snackbarRef.dismiss();
      })
    );
  }
}
